import { render, staticRenderFns } from "./single-pledge.vue?vue&type=template&id=0f88b642&scoped=true"
import script from "./single-pledge.vue?vue&type=script&lang=ts"
export * from "./single-pledge.vue?vue&type=script&lang=ts"
import style0 from "./single-pledge.vue?vue&type=style&index=0&id=0f88b642&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88b642",
  null
  
)

export default component.exports